// @ts-strict-ignore
import React from 'react'
import { Pressable, View } from 'react-native'
import { Control, Controller, FieldValues } from 'react-hook-form'
import I18n from 'APP/I18n'
import TextInput from 'APP/Converse/Inputs/TextInput'
import styled from 'styled-components/native'
import { PromptAddressItemProps } from './types'

const Container = styled.View`
  padding: 0 ${({ theme }) => theme.metrics.baseMargin}px;
`

interface PromptAddressControllerProps {
  name: string
  item: PromptAddressItemProps
  control: Control<FieldValues, unknown>
  openConditionalForm(value): void
  isFocused: boolean
  onFocus: (value: string | null) => void
}

export const PromptAddressController = ({
  name,
  item,
  control,
  openConditionalForm,
  onFocus,
}: PromptAddressControllerProps) => {
  const { required, title, placeholder_text, showRequiredAsterisk } = item
  const onPressIn = (value?: string) => {
    openConditionalForm({
      item: value ? { ...item, prefilled_values: value } : item,
      fieldName: name,
    })
  }

  return (
    <Controller
      control={control}
      name={name}
      rules={{
        required: required && I18n.t('Form.error.required'),
      }}
      render={({ field: { value, onBlur, ref }, fieldState: { error } }) => {
        const handlePress = () => {
          onFocus(name)
          onPressIn(value?.display)
        }

        return (
          <Container>
            <Pressable onPress={handlePress} testID={name}>
              <View pointerEvents="none">
                <TextInput
                  onBlur={onBlur}
                  ref={ref}
                  value={value?.display}
                  label={title}
                  showRequiredAsterisk={showRequiredAsterisk}
                  editable={false}
                  showSoftInputOnFocus={false}
                  placeholder={placeholder_text}
                  error={error?.message}
                />
              </View>
            </Pressable>
          </Container>
        )
      }}
    />
  )
}
